module.exports = __webpack_public_path__ + "img/Fiche chargé de photo et vidéo.77d67087.jpg";